function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 2.24963C7.27344 2.24963 4.25 5.12729 4.25 8.6715C4.25 12.7496 8.75 19.2123 10.4023 21.4445C10.4709 21.5387 10.5608 21.6154 10.6647 21.6682C10.7686 21.7211 10.8835 21.7487 11 21.7487C11.1165 21.7487 11.2314 21.7211 11.3353 21.6682C11.4392 21.6154 11.5291 21.5387 11.5977 21.4445C13.25 19.2132 17.75 12.7529 17.75 8.6715C17.75 5.12729 14.7266 2.24963 11 2.24963Z",
  stroke: "#8C30F5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 11.25C12.2426 11.25 13.25 10.2426 13.25 9C13.25 7.75736 12.2426 6.75 11 6.75C9.75736 6.75 8.75 7.75736 8.75 9C8.75 10.2426 9.75736 11.25 11 11.25Z",
  stroke: "#8C30F5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.0b11dfa6.svg";
export { ForwardRef as ReactComponent };